import { Collapse } from "reactstrap";
import I18n from "^/config/i18n";
import userUrls from "^/config/userUrls";

function MobileUserNav({ show }) {
  return (
    <Collapse isOpen={show}>
      <div className="bg-white border-top">
        <ul className="list-unstyled">
          {userUrls.profile && (
            <li className="border-bottom">
              <a
                href={userUrls.profile}
                className="px-3 d-block py-3 btn btn-link text-left"
              >
                <i className="las la-eye" /> {I18n.t("UserDropdown.profile")}
              </a>
            </li>
          )}
          {userUrls.settings && (
            <li className="border-bottom">
              <a
                href={userUrls.settings}
                className="px-3 d-block py-3 btn btn-link text-left"
              >
                <i className="las la-cog" /> {I18n.t("UserDropdown.settings")}
              </a>
            </li>
          )}
        </ul>
      </div>
    </Collapse>
  );
}
export default MobileUserNav;
